import Fuse from 'fuse.js'

const search = (questions) =>
  new Fuse(questions, {
    keys: ['question', 'answer'],
  })

export default search
